/* eslint-disable consistent-return */
import events from "../../../../common/event-aggregator";

export const validatePassword = function (passwordRules) {
  return function (value) {
    if (!passwordRules) {
      return true;
    }
    const isPasswordValid = passwordRules.every((rule) => {
      const regex = new RegExp(rule.pattern);
      return regex.test(value);
    });

    // ensure the PasswordStrength component gets upated
    // with the latest password value
    events.trigger(events.PASSWORD_VALUE_CHANGED, {
      passwordRules,
      passwordValue: value
    });

    return isPasswordValid;
  };
};
